import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-regular-investigation.reducer';

export const DoctorRegularInvestigationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorRegularInvestigationEntity = useAppSelector(state => state.doctorRegularInvestigation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorRegularInvestigationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.detail.title">DoctorRegularInvestigation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorRegularInvestigationEntity.id}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{doctorRegularInvestigationEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorRegularInvestigationEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{doctorRegularInvestigationEntity.lastUpdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorRegularInvestigationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorRegularInvestigationEntity.cursor}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{doctorRegularInvestigationEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{doctorRegularInvestigationEntity.createdBy}</dd>
          <dt>
            <span id="investigationType">
              <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.investigationType">Investigation Type</Translate>
            </span>
          </dt>
          <dd>{doctorRegularInvestigationEntity.investigationType}</dd>
          <dt>
            <span id="investigationId">
              <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.investigationId">Investigation Id</Translate>
            </span>
          </dt>
          <dd>{doctorRegularInvestigationEntity.investigationId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorRegularInvestigation.doctor">Doctor</Translate>
          </dt>
          <dd>{doctorRegularInvestigationEntity.doctor ? doctorRegularInvestigationEntity.doctor.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-regular-investigation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-regular-investigation/${doctorRegularInvestigationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorRegularInvestigationDetail;
